import React from "react";
import { Heading } from "@tennr/frontend/components/Heading";
import { BookFeaturesList } from "@tennr/frontend/components/BookFeaturesList";
import "./BookFeaturesSection.css";
import { LottieAnimation } from "@tennr/frontend/components/LottieAnimation";

export const BookFeaturesSection: React.FC = () => {
  return (
    <section className="book-features-section section-y">
      <div className="book-features-content">
        <Heading
          title={"CONVERT MORE REFERRALS"}
          heading="Fix the front end"
          body="High-growth providers do more with Tennr. Go from drowning in eFax, email, e-portal, and e-prescribe to accurate, automated pre-visit patient processing."
          dark
          variant="section"
          width={500}
        />
        <BookFeaturesList />
      </div>
      <LottieAnimation src="/lottie/PDP_intake.lottie" loop={true} autoplay={true} className="book-lottie" />
    </section>
  );
};
